import { render } from "./SurveyConfirmModal.vue?vue&type=template&id=72fb4e04&ts=true"
import script from "./SurveyConfirmModal.vue?vue&type=script&lang=ts"
export * from "./SurveyConfirmModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__